import React, {useEffect, useState} from 'react';
import {Card} from 'primereact/card';
import Tabs from '../../../../components/tabs';
import MinhasContribuicoesConstants from '../utils/MinhasContribuicoesConstants';
import {InputText} from 'primereact/inputtext';
import Container from '../../../../../vendors/components/Container';
import Field from '../../../../../vendors/components/Field';
import AnttButton from '../../../../../vendors/components/Button';
import MinhaContribuicaoController from '../controller/minha-contribuicao.controller';
import ContribuicaoItem from '../../../../components/contribuicao/ContribuicaoItem';
import {Paginator} from 'primereact/paginator';
import CloseButton from './CloseButton';
import If from '../../../../../vendors/components/If';
import EventoFinalizar from '../../../../components/evento-finalizar/EventoFinalizar';

const MAX_CHARS = 200;

export default function MinhasContribuicao() {

  const controller = new MinhaContribuicaoController();
  const tabs = MinhasContribuicoesConstants.TAB_LISTA;

  useEffect(() => {
    controller.init().then();
  }, []);

  return (
    <>
      <Card title="Minhas Contribuições">
        <Tabs
          onClick={(value: any) => controller.changeTab(value)}
          ativo={controller.tab}
          items={tabs}/>
        <div className="mt-5 minhas-contribuicoes">

          <Card
            footer={() =>
              <div className="flex justify-content-end mt-2"
              ><AnttButton
                type="button"
                onClick={() => controller.changeTab(controller.tab)}
                label="Pesquisar"/>
              </div>
            }
            title="Buscar nas minhas contribuições">
            <Container className="no-spaces">
              <Field col={12} className="no-spaces">
                <InputText
                  value={controller.searchParam}
                  onChange={(e) => {
                    if (e.target.value.length > MAX_CHARS) {
                      return;
                    }
                    controller.setSearchParam(e.target.value)
                  }}
                  maxLength={MAX_CHARS}
                />
                {controller.searchParam.length >= MAX_CHARS && (
                  <div style={{color: 'var(--danger)', marginTop: '10px'}}>
                    Limite de caracteres atingido ({MAX_CHARS} máx.).
                  </div>
                )}

              </Field>
            </Container>
          </Card>

          {controller.tab === '6' ? (
            <Card className="alerta-fixo" style={{marginBottom: '10px', height: '50%', visibility: 'visible'}}>
              <CloseButton/>
            </Card>
          ) : null}
          {controller.list.length > 0 ? (
            controller.list.map((evento: any, index: any) =>
              <div key={'teste' + index} className="mt-5">
                <Card title={`${evento.tipoEvento} ${evento.numero}`}>
                  <div className="flex justify-content-end">
                    <label className="titulo-institucional">
                      {evento.qtdContribuicoesPorContribuinte} {evento.qtdContribuicoesPorContribuinte > 1 ? 'contribuições' : 'contribuição'}
                    </label>
                  </div>
                  {evento.contribuicaoViewModels && evento.contribuicaoViewModels.length > 0 &&
                    evento.contribuicaoViewModels.map((contribuicao: any, jindex: any) =>
                      <div key={`ind-${jindex}`}>
                        <ContribuicaoItem key={`ind-${jindex}`}
                                          evento={evento}
                                          rollBackUrl={`/minhas-contribuicoes/inicio?tab=${controller.tab}`}
                                          controller={controller}
                                          podeEditar={evento.codSituacaoAudiencia !== 5}
                                          value={contribuicao}/>
                      </div>
                    )
                  }
                  <If condition={controller.tab === '6'}>
                    <div className="flex justify-content-end" style={{marginTop: '10px'}}>
                      <EventoFinalizar evento={evento}/>
                    </div>
                  </If>
                </Card>
              </div>
            )
          ) : (
            <div className="text-center" style={{margin: '20px 0'}}>
              Nenhum registro encontrado
            </div>
          )}
        </div>
        <div>
          <Paginator
            rows={controller.lazyParams.rows}
            first={controller.lazyParams.first}
            totalRecords={controller.total}
            onPageChange={(e: any) => controller.onPage(e)}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </div>
      </Card>

    </>
  );
}
